import * as API from './api'
import * as Types from './Types'

export function tryCreateLaundryTime(token, communityId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_LAUNDRY_TIME
    })

    API.createLaundryTime(token, communityId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_LAUNDRY_TIME_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_LAUNDRY_TIME_FAILED,
          payload: status
        })
      })
  }
}

export function tryUpdateLaundryTime(
  token,
  communityId,
  laundryTimeId,
  postData
) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_LAUNDRY_TIME
    })

    API.updateLaundryTime(token, communityId, laundryTimeId, postData)
      .then(response => {
        dispatch({
          type: Types.UPDATE_LAUNDRY_TIME_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.UPDATE_LAUNDRY_TIME_FAILED,
          payload: status
        })
      })
  }
}

export function tryDeleteLaundryTime(token, communityId, laundryTimeId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_LAUNDRY_TIME
    })

    API.deleteLaundryTime(token, communityId, laundryTimeId)
      .then(() => {
        dispatch({
          type: Types.DELETE_LAUNDRY_TIME_SUCCESS,
          payload: laundryTimeId
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_LAUNDRY_TIME_FAILED
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/LaundryTimes.js